import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Download Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-download-outline',
    templateUrl: './icon-download-outline.component.html',
    styleUrls: ['./icon-download-outline.component.scss'],
    standalone: false
})
export class IconDownloadOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
